import * as React from "react";
import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const featuredParts = [{
  id: 1,
  name: "Mando inversor cambio TCM cargadoras serie W",
  brand: "FIAT-HITACHI",
  model: "REF. CNH: 76036566",
  condition: "Nuevo ORIGINAL",
  price: "390 €",
  image: {
    src: "https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/TCM-1.jpg",
    srcset: "https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/TCM-1.jpg-wvc-srcset",
    sizes: "https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/TCM-1.jpg-wvc-sizes",
    alt: "Bomba Hidráulica TCM"
  }
}, {
  id: 2,
  name: "Turbo completo con actuador para HITACHI ZW220/250-6",
  brand: "HITACHI",
  model: "REF. HITACHI: K5327336",
  condition: "Nuevo\xA0",
  price: "2.940 €",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/doosan_swing_motor_studio.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/doosan_swing_motor_studio.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/doosan_swing_motor_studio.png-wvc-sizes",
    alt: "Motor de Giro Doosan DX225LC"
  }
}, {
  id: 3,
  name: "Bomba hidraulica circuito de frenos cargadora NEW-HOLLAND W270B",
  brand: "NEW HOLLAND",
  model: "REF. CNH: 87526207",
  condition: "Nuevo ORIGINAL",
  price: "2.495 €",
  image: {
    src: "https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/bomba-1.png",
    srcset: "https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/bomba-1.png-wvc-srcset",
    sizes: "https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/bomba-1.png-wvc-sizes",
    alt: "Bomba hidráulica de alta presión para maquinaria pesada New Holland"
  }
}];
export default function OportunidadesEnRecambios() {
  return <section id="oportunidades-en-recambios" className="bg-background text-foreground py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16 border-l-4 border-primary pl-6">
          <h2 className="text-4xl md:text-5xl font-default font-bold uppercase tracking-tight">
            Oportunidades en <span className="text-primary">Recambios</span>
          </h2>
          <p className="mt-4 text-muted-foreground max-w-2xl text-lg">Selección exclusiva de piezas con disponibilidad inmediata y precio muy competitivo respecto a la marca original, con entrega a cliente en 24, 48 o 72 horas dependiendo de su ubicación geográfica.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {featuredParts.map((part, i) => <Card key={part.id} data-index={i} className="bg-card border-border/40 overflow-hidden flex flex-col shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="bg-secondary/80 p-8 flex items-center justify-center aspect-square relative group overflow-hidden">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-muted)_0%,transparent_70%)] opacity-10"></div>
                
                {i === 0 && <img src="https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/TCM-1.jpg" data-wvc-srcset="https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/TCM-1.jpg-wvc-srcset" data-wvc-sizes="https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/TCM-1.jpg-wvc-sizes" alt="TCM machinery" className="object-cover w-full h-full absolute inset-0" loading="lazy" decoding="async" />}

                {i === 1 && <img src="https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/TURBO.jpg" data-wvc-srcset="https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/TURBO.jpg-wvc-srcset" data-wvc-sizes="https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/TURBO.jpg-wvc-sizes" alt={part.name} className="object-cover w-full h-full absolute inset-0" loading="lazy" decoding="async" />}

                {i === 2 && <img src="https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/bomba-1.png" data-wvc-srcset="https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/bomba-1.png-wvc-srcset" data-wvc-sizes="https://witty-mastiff.10web.cloud/wp-content/uploads/2026/05/bomba-1.png-wvc-sizes" alt={part.image.alt} className="object-cover w-full h-full absolute inset-0" loading="lazy" decoding="async" />}

                <div className="absolute top-4 left-4 bg-background/90 backdrop-blur-sm px-3 py-1.5 rounded-md text-xs font-bold tracking-wider border border-border/50 z-20 uppercase">
                  {part.brand}
                </div>
              </div>
              
              <CardHeader className="pb-4 pt-6">
                <CardDescription className="font-mono text-sm text-primary mb-2 font-semibold tracking-wider">
                  {part.model}
                </CardDescription>
                <CardTitle className="text-2xl font-default leading-tight">
                  {part.name}
                </CardTitle>
                <p className="text-sm text-muted-foreground mt-3 flex items-center gap-2">
                  <span className="inline-block w-2 h-2 rounded-md bg-primary/80"></span>
                  {part.condition}
                </p>
              </CardHeader>
              
              <CardFooter className="mt-auto pt-6 pb-8 border-t border-border/20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
                <div className="font-mono text-4xl font-bold text-primary tracking-tighter">
                  {part.price}
                </div>
                <Button asChild size="lg" className="w-full sm:w-auto font-bold tracking-wide">
                  <Link to="/ContactPage">
                    <MessageCircle className="mr-2 size-5" />
                    Consultar
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}